<template>
    <div class="container">
        <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Edit Vendor Category</h1>
        </div>
        <div class="global-main">
            <form @submit.prevent="editVendorCategoryData">
                <div class="tab-content-inner">
                    <div class="form-group">
                        <label> Name </label>
                        <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                        <has-error :form="form" field="name"></has-error>
                    </div>
                </div>
                <div class="form-group">
                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                    <router-link to="/vendorCategories" class="btn btn-primary float-right mr-2">Cancel</router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    name : '',
                }),
            };
        },
        methods: {
            editVendorCategoryData() {
                this.$Progress.start();
                this.form.put('/api/updateVendorCategory')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            toast.fire({
                                type: 'success',
                                title: 'Vendor Category updated successfully'
                            });
                            this.$router.push('/vendorCategoryies');
                        }else{
                            this.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Some problem in your form data'
                        });
                    });
            }
        },
        mounted() {
            this.$Progress.start();
            axios.get('/api/editVendorCategory/'+this.$route.params.id)
            .then(res => {
                if(res.status == 200){
                    this.form.id = res.data.id;
                    this.form.name = res.data.name;
                    this.$Progress.finish();
                }else{
                    this.$Progress.fail();
                }
            })
            .catch(err => {
                this.$Progress.fail();
            });

        },
        created() {
            //
        }
    }
</script>